import PropTypes from "prop-types";
import Alert from "@mui/material/Alert";
import Chip from "@mui/material/Chip";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import AdminTable from "components/admin/AdminTable";
import { GiftPreview } from "components/admin/GiftEditor";
import { useFetch } from "components/admin/hooks";
import api from "api/client";
import { formatDate, formatNumber } from "utils/format";

/** Danh sách người nhận của một lần chốt thưởng. */
function SettlementDialog({ settlement, onClose }) {
  const rows = useFetch(
    () => api.get(`/api/admin/mythic-arena/settlements/${settlement.id}`),
    [settlement.id]
  );
  const isSeason = settlement.kind === 1;

  return (
    <Dialog open onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        Thưởng {settlement.kindName} - {settlement.title}
        <MDTypography variant="caption" color="text" display="block">
          Chốt lúc {formatDate(settlement.cutoffAt)} · {formatNumber(settlement.rewarded)} người
          nhận / {formatNumber(settlement.players)} người có hạng
        </MDTypography>
      </DialogTitle>
      <DialogContent>
        {rows.error && <Alert severity="error">{rows.error}</Alert>}
        <AdminTable
          loading={rows.loading}
          rows={rows.data || []}
          emptyText="Lần chốt này không có ai nhận thưởng"
          columns={[
            { key: "rank", label: "Hạng", align: "right", width: 60 },
            {
              key: "name",
              label: "Người chơi",
              render: (r) => (
                <MDBox lineHeight={1.2}>
                  <MDTypography variant="button" display="block">
                    {r.name}
                  </MDTypography>
                  <MDTypography variant="caption" color="text">
                    #{r.userId}
                  </MDTypography>
                </MDBox>
              ),
            },
            {
              key: "trophy",
              label: isSeason ? "Cúp → mùa sau" : "Cúp",
              align: "right",
              render: (r) =>
                isSeason
                  ? `${formatNumber(r.trophy)} → ${formatNumber(r.trophyAfter)}`
                  : formatNumber(r.trophy),
            },
            {
              key: "gift",
              label: "Quà",
              wrap: true,
              render: (r) => <GiftPreview lines={r.lines} />,
            },
            {
              key: "mail",
              label: "Thư",
              render: (r) => {
                if (!r.mailId) return <Chip size="small" color="warning" label="Chưa gửi" />;
                return (
                  <Chip
                    size="small"
                    color={r.claimed ? "success" : "info"}
                    label={r.claimed ? "Đã nhận" : `Đã gửi ${formatDate(r.sentAt)}`}
                  />
                );
              },
            },
          ]}
        />
      </DialogContent>
      <DialogActions>
        <MDButton variant="text" color="secondary" onClick={onClose}>
          Đóng
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

SettlementDialog.propTypes = {
  settlement: PropTypes.shape({
    id: PropTypes.number.isRequired,
    kind: PropTypes.number,
    kindName: PropTypes.string,
    title: PropTypes.string,
    cutoffAt: PropTypes.string,
    players: PropTypes.number,
    rewarded: PropTypes.number,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SettlementDialog;
